export enum SiteSettingsScope {
  Cart = 'cart',
  Display = 'display',
  Ecom = 'ecom',
  Sfcc = 'sfcc',
  Authorization = 'authorization',
  MyJabra = 'myjabra',
  Shipping = 'shipping',
  Returns = 'returns',
}
